import { useQuery, useQueryClient } from "@tanstack/react-query"
import { DeclaracionModelo303DtoProps } from "./DTOs/DeclaracionModelo303Dto"
import { GetDatosDeclaracionModelo303DtoProps } from "./DTOs/GetDatosDeclaracionModelo303Dto"
import { GetDatosDeclaracionModelo390DtoProps } from "./DTOs/GetDatosDeclaracionModelo390Dto"
import { GetDatosDeclaracionModelo349DtoProps } from "./DTOs/GetDatosDeclaracioneModelo349Dto"
import {
  getDeclaracionModelo180,
  getDeclaracionModelo190,
  getDeclaracionModelo303,
  getDeclaracionModelo347,
  getDeclaracionModelo349,
  getDeclaracionModelo390,
  queryParamsGetDeclaracionModelo,
} from "./DeclaracionModelo"
import { PeriodoDeclaracionModeloEnumType } from "./Types/PeriodoDeclaracionModeloEnum"

type MapRespToDtoFn = (
  resp:
    | GetDatosDeclaracionModelo303DtoProps
    | GetDatosDeclaracionModelo390DtoProps,
  ejercicio?: string,
  periodo?: PeriodoDeclaracionModeloEnumType | null,
  razonSocial?: string | null,
  nif?: string | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) => DeclaracionModelo303DtoProps | any

interface Declaration303Props {
  queryParams: queryParamsGetDeclaracionModelo
  mapRespToDto: MapRespToDtoFn
  periodo?: { label: string; value: PeriodoDeclaracionModeloEnumType | null }
  razonSocial?: string | null
  nif?: string | null
  year?: string
}
export const useDeclaracion303 = ({
  queryParams,
  mapRespToDto,
  razonSocial,
  nif,
  periodo,
  year,
}: Declaration303Props) => {
  const queryClient = useQueryClient()
  const {
    data: declaracion303Data,
    error: declaracion303DataError,
    isLoading: declaracion303DataIsLoading,
    refetch: declaracion303DataRefetch,
  } = useQuery({
    queryKey: ["declaracion303Data", queryParams],
    queryFn: () => getDeclaracionModelo303(queryParams),
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
    staleTime: 1000 * 60 * 60 * 8,
    select: (data) => {
      if (!data) return
      return mapRespToDto(data, year, periodo?.value, razonSocial, nif)
    },
  })
  const declaracion303DataInvalidation = () =>
    queryClient.invalidateQueries({
      queryKey: ["declaracion303Data", queryParams],
    })

  return {
    declaracion303Data,
    declaracion303DataError,
    declaracion303DataIsLoading,
    declaracion303DataRefetch,
    declaracion303DataInvalidation,
  }
}

type MapRespToDtoArgs = {
  resp:
    | GetDatosDeclaracionModelo303DtoProps
    | GetDatosDeclaracionModelo390DtoProps
    | GetDatosDeclaracionModelo349DtoProps
  ejercicio?: string | number
  periodo?: PeriodoDeclaracionModeloEnumType | null
  razonSocial?: string | null
  nif?: string | null
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type MapRespToDtoFn390 = (args: MapRespToDtoArgs) => any

interface Declaration390Props {
  queryParams: queryParamsGetDeclaracionModelo
  mapRespToDto?: MapRespToDtoFn390
  razonSocial?: string | null
  nif?: string | null
  year?: number
}

export const useDeclaracion180 = ({ queryParams }: Declaration390Props) => {
  const queryClient = useQueryClient()
  const {
    data: declaracion180Data,
    error: declaracion180DataError,
    isLoading: declaracion180DataIsLoading,
    refetch: declaracion180DataRefetch,
  } = useQuery({
    queryKey: ["declaracion180Data", queryParams],
    queryFn: () => getDeclaracionModelo180(queryParams),
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
    staleTime: 1000 * 60 * 60 * 8,
  })
  const declaracion180DataInvalidation = () =>
    queryClient.invalidateQueries({
      queryKey: ["declaracion180Data", queryParams],
    })
  return {
    declaracion180Data,
    declaracion180DataError,
    declaracion180DataIsLoading,
    declaracion180DataRefetch,
    declaracion180DataInvalidation,
  }
}

export const useDeclaracion390 = ({ queryParams }: Declaration390Props) => {
  const queryClient = useQueryClient()
  const {
    data: declaracion390Data,
    error: declaracion390DataError,
    isLoading: declaracion390DataIsLoading,
    refetch: declaracion390DataRefetch,
  } = useQuery({
    queryKey: ["declaracion390Data", queryParams],
    queryFn: () => getDeclaracionModelo390(queryParams),
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
    staleTime: 1000 * 60 * 60 * 8,
  })
  const declaracion390DataInvalidation = () =>
    queryClient.invalidateQueries({
      queryKey: ["declaracion390Data", queryParams],
    })

  return {
    declaracion390Data,
    declaracion390DataError,
    declaracion390DataIsLoading,
    declaracion390DataRefetch,
    declaracion390DataInvalidation,
  }
}

export const useDeclaracion190 = ({ queryParams }: Declaration390Props) => {
  const queryClient = useQueryClient()
  const {
    data: declaracion190Data,
    error: declaracion190DataError,
    isLoading: declaracion190DataIsLoading,
    refetch: declaracion190DataRefetch,
  } = useQuery({
    queryKey: ["declaracion190Data", queryParams],
    queryFn: () => getDeclaracionModelo190(queryParams),
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
    staleTime: 1000 * 60 * 60 * 8,
  })
  const declaracion190DataInvalidation = () =>
    queryClient.invalidateQueries({
      queryKey: ["declaracion190Data", queryParams],
    })

  return {
    declaracion190Data,
    declaracion190DataError,
    declaracion190DataIsLoading,
    declaracion190DataRefetch,
    declaracion190DataInvalidation,
  }
}

interface DeclarationProps {
  queryParams: queryParamsGetDeclaracionModelo
}

export const useDeclaracion347 = ({ queryParams }: DeclarationProps) => {
  const queryClient = useQueryClient()
  const {
    data: declaracion347Data,
    error: declaracion347DataError,
    isLoading: declaracion347DataIsLoading,
    refetch: declaracion347DataRefetch,
  } = useQuery({
    queryKey: ["declaracion347Data", queryParams],
    queryFn: () => getDeclaracionModelo347(queryParams),
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
    staleTime: 1000 * 60 * 60 * 8,
  })
  const declaracion347DataInvalidation = () =>
    queryClient.invalidateQueries({
      queryKey: ["declaracion347Data", queryParams],
    })
  return {
    declaracion347Data,
    declaracion347DataError,
    declaracion347DataIsLoading,
    declaracion347DataRefetch,
    declaracion347DataInvalidation,
  }
}

export const useDeclaracion349 = ({
  queryParams,
}: {
  queryParams: queryParamsGetDeclaracionModelo
}) => {
  const queryClient = useQueryClient()
  const {
    data: declaracion349Data,
    error: declaracion349DataError,
    isLoading: declaracion349DataIsLoading,
    refetch: declaracion349DataRefetch,
  } = useQuery({
    queryKey: ["declaracion349Data", queryParams],
    queryFn: () => getDeclaracionModelo349(queryParams),
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
    staleTime: 1000 * 60 * 60 * 8,
  })
  const declaracion349DataInvalidation = () =>
    queryClient.invalidateQueries({
      queryKey: ["declaracion349Data", queryParams],
    })
  return {
    declaracion349Data,
    declaracion349DataError,
    declaracion349DataIsLoading,
    declaracion349DataRefetch,
    declaracion349DataInvalidation,
  }
}
